/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { externalKeysGetGcpKms } from "../funcs/externalKeysGetGcpKms.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GcpKmsKey } from "../models/components/gcpkmskey.js";
import {
  GetGcpKmsKeyRequest,
  GetGcpKmsKeySecurity,
} from "../models/operations/getgcpkmskey.js";
import { unwrapAsync } from "../types/fp.js";
export type GetGcpKmsKeyQueryData = GcpKmsKey;

export function prefetchGetGcpKmsKey(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetGcpKmsKeyRequest,
  security?: GetGcpKmsKeySecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetGcpKmsKeyQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetGcpKmsKeyQuery(
  client$: GramCore,
  request: GetGcpKmsKeyRequest,
  security?: GetGcpKmsKeySecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<GetGcpKmsKeyQueryData>;
} {
  return {
    queryKey: queryKeyGetGcpKmsKey({
      id: request.id,
      gramSession: request.gramSession,
    }),
    queryFn: async function getGcpKmsKeyQueryFn(
      ctx,
    ): Promise<GetGcpKmsKeyQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(externalKeysGetGcpKms(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetGcpKmsKey(
  parameters: { id: string; gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "externalKeys", "getGcpKms", parameters];
}
